export const items = (devMessage) => {
	return [
		{
			key: '1',
			label: 'Mensaje para desarrolladores:',
			children: <p>{devMessage}</p>,
		},
	];
};
